import React from "react";
import {
  binderLetterModalClosed,
  getBinderLetterFromURL,
  getBinderLetterStatus,
  gettingBinderLetterPDFSuccess,
} from "../../../store/components";
import LoadingSpinner from "../../BinderLoading";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import CancelIcon from "@material-ui/icons/Cancel";
import * as theme from "../../../theme";
import { makeStyles } from "@material-ui/core/styles";
import { useState, useEffect } from "react";
import { getCoverIdForExpiryDate } from "../../../store/businesslogic/hardwiredlogic";
import {
  emailBodyBindProspect,
  emailBodyBindLetter,
} from "../../../helper/constants";
import moment from "moment";
import ReactLoading from "react-loading";

import {
  binderLetterNull,
  getBinderDetails,
  getEncryCRSProspectIdFromMyBinders,
  getSelectedBinderDetailLocationAddress,
  getSelectedBinderDetails,
} from "../../../store/mybinder";
import { getBrokerInformation } from "../../../store/broker";

import { ImportantDevices, LabelImportant } from "@material-ui/icons";
import {
  PossibleApiStatusValues,
  processCoversData,
} from "../../../store/helperfuncs";
import SelectedBinderLetterCoverByCoverType from "./SelectedBinderLetterCoverByCoverType";
import CoverTypeSelection from "./CoverTypeSelection";
import _ from "lodash";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";
import PdfSettingsModal from "../../PdfSettingsModal";
import externalTranslations from "../../../utils/translations";

const translations = {
  en: {
    modal: {
      customizeBinderLetterHeading: "Customize your Binder Letter",
      customizeBinderLetterSubHeading:
        "From here, you can customize the details of your binder letter.",
      generalBindInformation: "General Bind Information",
      descriptionOfOperations: "Description of Operations",
      commentsPlaceholder: "Comments",
      generalBrokerComments: "General Broker Comments",
      descriptionPlaceholder: "Description",
      selectCoveragesAndLimits: "Select Coverages and Limits to Include",
      filterCoversByType: "Filter Covers by their type:",
    },
    binderLetter: {
      downloadBinderLetterEmailAgain: "Download Binder Letter Email again",
      downloadFailedReported: "Download failed! We have reported this failure",
      confirmAndCreateBinderLetterEmail:
        "Confirm and Create Binder Letter Email",
      downloadBinderLetterAgain: "Download Binder Letter again",
      confirmAndCreateBinderLetter: "Confirm and Create Binder Letter",
      confirmAndCreateBinderInsurance:"Confirmation of your insurance"
    },
  },
  fr: {
    modal: {
      customizeBinderLetterHeading: "Personnalisez votre lettre de mandataire",
      customizeBinderLetterSubHeading:
        "À partir d'ici, vous pouvez personnaliser les détails de votre lettre de mandataire.",
      generalBindInformation: "Informations Générales de Liaison",
      descriptionOfOperations: "Description des Opérations",
      commentsPlaceholder: "Commentaires",
      generalBrokerComments: "Commentaires Généraux du Courtier",
      descriptionPlaceholder: "Description",
      selectCoveragesAndLimits:
        "Sélectionnez les garanties et les limites à inclure",
      filterCoversByType: "Filtrer les couvertures par leur type :",
    },
    binderLetter: {
      confirmAndCreateBinderInsurance:"Confirmation de votre assurance",
      downloadBinderLetterEmailAgain:
        "Télécharger à nouveau l'email de lettre de mandataire",
      downloadFailedReported:
        "Le téléchargement a échoué! Nous avons signalé cet échec",
      confirmAndCreateBinderLetterEmail:
        "Confirmer et créer l'email de lettre de mandataire",
      downloadBinderLetterAgain:
        "Télécharger à nouveau la lettre de mandataire",

      confirmAndCreateBinderLetter:
        "Confirmer et créer la lettre de mandataire",
    },
  },
};

const BindLetterModal = (props) => {
  const [coverinfo, setCoverInfo] = useState([]);
  const [allcovers, setAllCovers] = useState([]);
  const [allCoverValue, setAllCoverValue] = useState([]);
  const [coversasis, setAllCoversasis] = useState([]);
  const [coverTypes, setCoverTypes] = useState("RESPONSE");
  const [binderLetter, setBinderLetter] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const binderDetails = useSelector(getSelectedBinderDetails);
  const binderAddreses = useSelector(getSelectedBinderDetailLocationAddress);
  const binderLocationsAddesses =
    binderAddreses && binderAddreses.state
      ? Object.keys(binderAddreses.state).map((addressId) => ({
          id: addressId,
          ...binderAddreses.state[addressId],
        }))
      : [];
  const [binderLetterLocationObject, setBinderLetterLocationObject] = useState(
    {}
  );
  const [locationValueObj, setLocationValueObj] = useState({});
  const [checkedLocationValues, setCheckedLocationValues] = useState({});
  const [filteredCoverTypes, setFilteredCoverTypes] = useState([]);
  const broker = useSelector(getBrokerInformation);
  const languagecode = broker.information.languagepreference || "en";

  const [storeBinder, setStoreBinder] = useState({
    policyid: "",
    description: "",
    comment: "",
    covers: "",
    locations: "",
  });
  const useStyles = makeStyles(
    theme.customMaterialUIClassForScrollBarDarkBackgrond
  );
  const dispatch = useDispatch();
  const binderLetterStatus = useSelector(getBinderLetterStatus);
  const prospectidEncryCRS = useSelector(getEncryCRSProspectIdFromMyBinders());

  // TODO: Put this in the redux store. All Apis should be called from
  //      redux store
  const storeBinderDetails = async (parms = {}) => {
    const storeBinderDetails = { ...storeBinder };
    const selectedList = [];
    selectedItems.forEach((m) => {
      selectedList.push(Object.values(m));
    });
    storeBinderDetails.policyid = props.binderFormData.binderdetails._id;
    storeBinderDetails.covers = Object.fromEntries(selectedList);
    storeBinderDetails.locations = checkedLocationValues;
    const response = await fetch(
      `${process.env.REACT_APP_BASICSERVICE}/api/policies/store-binder-later-details`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": localStorage.getItem("jwt"),
        },
        body: JSON.stringify(storeBinderDetails),
      }
    );
    const putData = await response.json();
    const binderId = window.location.href.split("=").slice(-1)[0];
    if (response.ok) {
      toast.success(
        externalTranslations[languagecode].fileDownloadNotification
      );
      const pdfLanguagePrefIsFrench =
      localStorage.getItem("pdfLanguagePrefIsFrench") === "true";
      dispatch(getBinderDetails({ policyid: binderId }));

      dispatch(
        getBinderLetterFromURL({
          binderid: binderId,
          id: prospectidEncryCRS,
          pdf_language_selected: pdfLanguagePrefIsFrench ? "fr" : "en",
          ...parms,
        })
      );
      await dispatch(binderLetterModalClosed());
    } else {
      toast.error("binder letter not created");
    }
  };

  useEffect(() => {
    const binderLetterCovers =
      props && props.binderFormData.binderdetails.allcovers;
    const covers = processCoversData(binderLetterCovers);
    setAllCovers(covers);
    setAllCoverValue(props && props.binderFormData.binderdetails.covers);
    setAllCoversasis(props && props.binderFormData.binderdetails.coversasis);
    setCoverInfo(props && props.binderFormData.binderdetails.covertypes);
    setStoreBinder(
      props && props.binderFormData.binderdetails.policySelectedResponse
    );

    let obj = props && props?.binderFormData?.binderdetails?.locations;
    setLocationValueObj(obj);

    if (props?.binderFormData?.binderdetails?.policySelectedResponse?.covers) {
      const selectedCoversData =
        props.binderFormData.binderdetails.policySelectedResponse?.covers;
      const selectedItemList = [];
      Object.keys(selectedCoversData).map((value) => {
        selectedItemList.push({
          key: value,
          value: selectedCoversData[value],
        });
      });
      setSelectedItems(selectedItemList);
    }
  }, []);

  useEffect(() => {
    let locationsObj =
      props?.binderFormData?.binderdetails?.policySelectedResponse?.locations;
    const newObj = {};
    if (locationsObj) {
      Object.keys(locationsObj)?.forEach((key) => {
        newObj[key] = { ...locationsObj[key] };

        // If HasBuildings indicates that there should be buildings, initialize it
        if (hasBuilding) {
          newObj[key].buildings = {};
        }
      });
      setCheckedLocationValues(newObj);

      if (newObj) {
        const locObject = {};
        const location = Object.values(newObj);
        if (location.length > 0) {
          let data = binderLocationsAddesses?.map((item, index) => {
            locObject[item.id] = [];
            if (location?.[index]) {
              const dataObj = Object.keys(location?.[index])?.map((val, i) =>
                locObject[item.id].push({ key: val })
              );
            }
          });
          setBinderLetterLocationObject(locObject);
        }
      }
    }
  }, [props?.binderFormData?.binderdetails?.policySelectedResponse?.locations]);

  useEffect(() => {
    setFilteredCoverTypes(
      allcovers?.filter((coverItem) => coverItem.covertypecode === coverTypes)
    );
  }, [coverTypes, allcovers]);

  const defaultSelectedCheckedValue = (
    id,
    locationId,
    buildingId,
    isBuilding
  ) => {
    if (coverTypes === "LOCATION" && binderLetterLocationObject) {
      if (binderLetterLocationObject[locationId] && !isBuilding) {
        let createDefault = binderLetterLocationObject[locationId].filter(
          (item) => item.key == id
        );
        return createDefault.length > 0;
      } else {
        // Using lodash to safely access the nested id
        let selectedByDefault = _.get(checkedLocationValues, [
          locationId,
          "buildings",
          buildingId,
          id,
        ]);
        // Return true if the id exists, false otherwise
        return selectedByDefault !== undefined;
      }
    }
    let selected = selectedItems.filter((item) => item.key == id);
    return selected.length > 0;
  };
  const handleChecked = (
    checkbox,
    id,
    location,
    buildingData = {},
    isBuilding = false,
    buildingIndex
  ) => {
    const isSelected = selectedItems
      .map((item) => {
        if (item.key === id.toString()) {
          return id.toString();
        }
      })
      .indexOf(id.toString());
    const checkedLocation = { ...checkedLocationValues };
    if (checkbox.target.checked) {
      if (location && coverTypes === "LOCATION" && checkbox.target.value) {
        if (isBuilding) {
          const id = checkbox.target.value;

          if (!checkedLocation[location.id]) {
            checkedLocation[location.id] = {}; // Initialize as an empty object if it doesn't exist
          }

          if (!checkedLocation[location.id].buildings) {
            checkedLocation[location.id].buildings = {}; // Now it's safe to set 'buildings' property
          }

          if (
            checkedLocation[location.id].buildings[buildingIndex] === undefined
          ) {
            checkedLocation[location.id].buildings[buildingIndex] = {};
          }
          checkedLocation[location.id].buildings[buildingIndex][
            checkbox.target.value
          ] =
            locationValueObj[location.id].buildings[buildingIndex][
              checkbox.target.value
            ];

          setCheckedLocationValues(checkedLocation);

          if (checkedLocationValues) {
            const locObject = {};

            // Use the locationId and buildingIndex that are passed to the function
            const locationData = checkedLocationValues[location.id];
            if (
              locationData &&
              locationData.buildings &&
              locationData.buildings[buildingIndex]
            ) {
              const buildingKey = `${location.id}_building_${buildingIndex}`;
              locObject[buildingKey] = Object.keys(
                locationData.buildings[buildingIndex]
              ).map((key) => ({ key: key }));
            }

            setBinderLetterLocationObject(locObject);
          }
        } else {
          const id = checkbox.target.value;
          if (checkedLocation[location.id] === undefined) {
            checkedLocation[location.id] = {};
          }
          checkedLocation[location.id][checkbox.target.value] =
            locationValueObj[location.id][checkbox.target.value];
          setCheckedLocationValues(checkedLocation);

          if (checkedLocationValues) {
            const locObject = {};
            const location = Object.values(checkedLocationValues);
            if (location.length > 0) {
              let data = binderLocationsAddesses?.map((item, index) => {
                locObject[item.id] = [];
                if (location?.[index]) {
                  const dataObj = Object.keys(location?.[index])?.map(
                    (val, i) => locObject[item.id].push({ key: val })
                  );
                }
              });
              setBinderLetterLocationObject(locObject);
            }
          }
        }
      }

      if (coverTypes != "LOCATION") {
        if (allCoverValue != null) {
          selectedItems.push({
            key: id.toString(),
            value: allCoverValue[id].toString(),
          });
        } else {
          selectedItems.push({
            key: id.toString(),
            value: coversasis[id].toString(),
          });
        }
      }
    } else {
      if (coverTypes === "LOCATION" && location) {
        if (checkedLocation[location.id]) {
          if (isBuilding) {
            delete checkedLocation[location.id].buildings[buildingIndex][
              id.toString()
            ];
          } else {
            //delete location object when uncheck
            delete checkedLocation[location.id][id.toString()];
          }
          setCheckedLocationValues(checkedLocation);
        }
      }
      if (coverTypes != "LOCATION") selectedItems.splice(isSelected, 1);
    }
  };

  const locationsData = props?.binderFormData?.binderdetails?.locations;
  const hasBuilding = _.some(locationsData, (location) => {
    return _.some(location, (value, key) => key.includes("buildings"));
  });

  const buildingsData = hasBuilding ? locationsData : null;

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    // These options are needed to round to whole numbers if that's what you want.
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  const getCoversasisValue = (id, locationId, buildingKey) => {
    // Added buildingKey parameter
    let returnValue = "";

    // Adjusting the logic to consider buildingKey
    let covers;
    if (
      buildingKey &&
      locationValueObj[locationId] &&
      locationValueObj[locationId].buildings[buildingKey]
    ) {
      covers = locationValueObj[locationId].buildings[buildingKey];
    } else {
      covers =
        (locationValueObj && locationId >= 0 && locationValueObj[locationId]) ||
        allCoverValue ||
        coversasis;
    }

    let coversasisvalue = (covers && covers[id]) || "-";

    if (!coversasisvalue) return null;
    if (id === getCoverIdForExpiryDate()) {
      returnValue =
        coversasisvalue &&
        moment(new Date(coversasisvalue)).format("DD MMM YYYY");
    } else if (isNaN(coversasisvalue)) {
      returnValue = coversasisvalue + "";
    } else {
      if (coversasisvalue > 0 && coversasisvalue <= 2) {
        returnValue = coversasisvalue * 100 + "%";
      } else {
        returnValue = formatter.format(coversasisvalue);
      }
    }
    return returnValue;
  };

  const style = {
    minHeight: "2vh",
    fontSize: "1.8vmin",
    fontFamily: "GibsonRegular",
  };
  const inputStyle = {
    marginLeft: "-57%",
    borderRadius: "10px",
    border: "0px",
    width: "163%",
    lineHeight: "39px",
    marginBottom: "14px",
    marginTop: "-4px",
    padding: "0 10px",
  };

  const handleCloseButton = () => {
    dispatch(binderLetterModalClosed());
  };

  const classes = useStyles();
  const heights = {
    desc: "8%",
    proceedbutton: "8%",
    somegapbetween: "2%",
    remainingHeight: "",
  };
  const hDist = {
    headingHeight: "10%",
    remainingHeight: "",
  };
  hDist.remainingHeight = `calc(100% - ${hDist.headingHeight})`;
  heights.remainingHeight = `calc(100% - ${heights.desc} - ${heights.proceedbutton} - ${heights.somegapbetween})`;
  const handleDescriptionChange = (event) => {
    const temp = { ...storeBinder };
    temp.description = event.target.value;
    temp.policyid = props.binderId;
    setStoreBinder(temp);
  };

  const handleBrokerCommentChange = (event) => {
    const temp = { ...storeBinder };
    temp.comment = event.target.value;
    setStoreBinder(temp);
  };
  return (
    <CommonModalForConfiguration
      heading={translations[languagecode]?.modal.customizeBinderLetterHeading}
      subHeading={
        translations[languagecode]?.modal.customizeBinderLetterSubHeading
      }
      handleCloseButton={handleCloseButton}
      classes={classes}
      heights={heights}
      hDist={hDist}
      storeBinderDetails={storeBinderDetails}
      binderLetterStatus={binderLetterStatus}
      binderDetails={binderDetails}
    >
      <CommonHeading
        text={translations[languagecode]?.modal.generalBindInformation}
      />
      <CommonInput
        label={translations[languagecode]?.modal.descriptionOfOperations}
        onChange={handleDescriptionChange}
        placeholder={translations[languagecode]?.modal.commentsPlaceholder}
        value={storeBinder && storeBinder.description}
      />
      <CommonInput
        label={translations[languagecode]?.modal.generalBrokerComments}
        onChange={handleBrokerCommentChange}
        placeholder={translations[languagecode]?.modal.descriptionPlaceholder}
        value={storeBinder && storeBinder.comment}
      />
      <div style={{ height: "2vh" }}></div>
      <CommonHeading
        text={translations[languagecode]?.modal.selectCoveragesAndLimits}
      />
      <div style={{ height: "2vh" }}></div>
      <div style={{ paddingLeft: "7vmin" }}>
        {translations[languagecode]?.modal.filterCoversByType}
      </div>
      <CoverTypeSelection
        setCoverTypes={setCoverTypes}
        allcovers={allcovers}
        coverinfo={coverinfo}
      />
      <div style={{ height: "2vh" }}></div>
      <SelectedBinderLetterCoverByCoverType
        coverOfCoverType={filteredCoverTypes}
        locations={binderLocationsAddesses}
        buildings={buildingsData}
        coverTypes={coverTypes ? coverTypes : "RESPONSE"}
        getCoversasisValue={getCoversasisValue}
        handleChecked={handleChecked}
        storeBinder={storeBinder}
        defaultSelectedCheckedValue={defaultSelectedCheckedValue}
      />
      <div style={{ height: "5vh" }}></div>
    </CommonModalForConfiguration>
  );
};

const CommonHeading = ({ text }) => {
  return (
    <section
      style={{
        width: "100%",
        height: "4vh",
        fontSize: "2.2vmin",
        color: theme.COLORS.secondary_skyblue,
        display: "flex",
        alignItems: "center",
      }}
    >
      {text}
    </section>
  );
};
const CommonInput = ({
  label = "Sample label",
  onChange,
  value,
  placeholder,
}) => {
  return (
    <section
      style={{
        minHeight: "8vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        paddingTop: "2vh",
      }}
    >
      <div
        style={{
          width: "30%",
          paddingLeft: "7vmin",
          height: "100%",
          display: "flex",
          alignItems: "flex-start",
        }}
      >
        {label}
      </div>
      <div style={{ width: "50%", minHeight: "100%" }}>
        <textarea
          style={{
            width: "100%",
            height: "100%",
            padding: "2vmin",
            color: theme.COLORS.dark_navy_blue,
            border: `2px solid ${theme.COLORS.secondary_skyblue}`,
            borderRadius: 5,
            letterSpacing: 1.2,
            backgroundColor: theme.COLORS.tertiary_ligthindigo,
          }}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          // onBlur={handleBlur}
          // value={reason}
        ></textarea>
      </div>
    </section>
  );
};

const CommonModalForConfiguration = ({
  heading,
  subHeading,
  handleCloseButton,
  classes,
  heights,
  hDist,
  children,
  storeBinderDetails,
  binderLetterStatus,
  binderDetails,
}) => {
  const dispatch = useDispatch();
  const [isModalOpen,setIsModalOpen]=useState(false)
  const broker = useSelector(getBrokerInformation);
  const languagecode = broker.information.languagepreference || "en";

  const pdfLanguagePrefIsFrench =
  localStorage.getItem("pdfLanguagePrefIsFrench") === "true";
const languagepreference = pdfLanguagePrefIsFrench ? "fr" : "en"

  useEffect(() => {
    const onKeyPressed = (e) => {
      if (e.keyCode === 27) {
        dispatch(binderLetterModalClosed());
      }
    };
    document.addEventListener("keydown", onKeyPressed);

    return () => {
      document.removeEventListener("keydown", onKeyPressed);
    };
  }, [dispatch]);
  var insurerEmail = binderDetails?.binderdetails?.insurerContacts?.[0]?.emails
    ?.filter((x) => x?.default == "Yes")
    .map((x) => x.email)
    .join("");


  return (
  <> 
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
      }}
    >
      <div
        style={{
          height: hDist.headingHeight,
          width: "100%",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "100%",
            backgroundColor: theme.COLORS.secondary_skyblue,
            fontSize: "1.9vmin",
            letterSpacing: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "white",
            fontFamily: "GibsonRegular",
          }}
        >
          {heading}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: hDist.remainingHeight,
          backgroundColor: theme.COLORS.primary_navyblue,
          padding: "2vmin",
          paddingTop: 0,
        }}
      >
        <div style={{ position: "absolute", top: 0, right: 0 }}>
          <CancelIcon
            fontSize="large"
            style={{ cursor: "pointer", color: "white" }}
            onClick={handleCloseButton}
          ></CancelIcon>
        </div>

        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            color: "white",
            fontFamily: "GibsonRegular",
          }}
        >
          <div
            style={{
              width: "100%",
              height: heights.desc,
              fontSize: "1.7vmin",
              letterSpacing: 1,
              fontFamily: "GibsonLight",
              padding: "2vmin",
              paddingLeft: 0,
            }}
          >
            {subHeading}
          </div>

          <div
            style={{
              width: "100%",
              height: heights.remainingHeight,
              fontSize: "1.9vmin",
              letterSpacing: 1,
              overflow: "auto",
            }}
            className={classes.responses}
          >
            {children}
          </div>
          <div
            style={{
              width: "100%",
              height: heights.somegapbetween,
            }}
          ></div>
          <div
            style={{
              display: "inline-flex",
              height: heights.proceedbutton,
            }}
          >
            {/* <div
              style={{
                width: "45%",
                backgroundColor: theme.COLORS.secondary_orange,
                fontSize: "1.9vmin",
                marginLeft: "3%",
                marginRight: "1%",
                letterSpacing: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: 10,
                cursor: "Pointer",
              }}
              onClick={() => {
                storeBinderDetails();
              }}
            >
              {binderLetterStatus === PossibleApiStatusValues.loading ? (
                <ReactLoading type="bars" width={30} height={30} />
              ) : binderLetterStatus === PossibleApiStatusValues.success ? (
                <div>
                  {
                    translations[languagecode]?.binderLetter
                      .downloadBinderLetterAgain
                  }
                </div>
              ) : binderLetterStatus === PossibleApiStatusValues.failed ? (
                <div>
                  {
                    translations[languagecode]?.binderLetter
                      .downloadFailedReported
                  }
                </div>
              ) : (
                <div>
                  {
                    translations[languagecode]?.binderLetter
                      .confirmAndCreateBinderLetter
                  }
                </div>
              )}
            </div> */}
            {/* <div
              style={{
                width: "45%",
                backgroundColor: theme.COLORS.secondary_orange,
                fontSize: "1.9vmin",
                letterSpacing: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: 10,
                cursor: "Pointer",
              }}
              onClick={() => {
                var effectiveDate = new Date(
                  binderDetails.binderdetails.effectivedate
                )?.toDateString();
                var businessName =
                  binderDetails.binderdetails.CLIENT_BUSINESS_NAME;
                const brokerName = binderDetails.binderdetails.brokername;
                var premium = binderDetails.binderdetails.covers[3];
                const clientName = binderDetails.binderdetails.CLIENT_EMAIL;
                storeBinderDetails({
                  downloadingEml: true,
                  mailto: clientName ? clientName : "",
                  bcc: "",
                  body: emailBodyBindLetter.replace(
                    "<<brokername>>",
                    brokerName + " " //temporay fix, but the replace function is removing the last char in string everytime. the space is a gap to ensure it doesn't
                  ),
                  subject: "Confirmation of your insurance",
                });
              }}
            >
              {binderLetterStatus === PossibleApiStatusValues.loading ? (
                <ReactLoading type="bars" width={30} height={30} />
              ) : binderLetterStatus === PossibleApiStatusValues.success ? (
                <div>
                  {
                    translations[languagecode]?.binderLetter
                      .downloadBinderLetterEmailAgain
                  }
                </div>
              ) : binderLetterStatus === PossibleApiStatusValues.failed ? (
                <div>
                  {
                    translations[languagecode]?.binderLetter
                      .downloadFailedReported
                  }
                </div>
              ) : (
                <div>
                  {
                    translations[languagecode]?.binderLetter
                      .confirmAndCreateBinderLetterEmail
                  }
                </div>
              )}
            </div> */}
            <DropdownButton
              style={{
                width: "100%",
                marginLeft: "4%",
                marginRight: "1.5%",
                backgroundColor: theme.COLORS.secondary_orange,
                fontSize: "1.9vmin",
                letterSpacing: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: 10,
                cursor: "Pointer",
              }}
              className="custom-dropdown-button-2"
              // variant="warning"
              title={externalTranslations[languagecode]?.certificateDownloadOptions}
              id="bg-nested-dropdown"
              // show={dropdownOpen}
              drop={"up"}
              // onToggle={handleDropdownToggle}
            >
              <Dropdown.Item
                style={{
                  width: "100%",
                }}
                eventKey="0"
                onClick={() => {
                  // setuseEmail(false);
                  setIsModalOpen(true);
                }}
              >
                {externalTranslations[languagecode]?.editPDFOptions}
              </Dropdown.Item>
              <Dropdown.Item
                style={{
                  width: "100%",
                }}
                eventKey="1"
                onClick={() => {
                  // setuseEmail(false);
                  // setIsModalOpen(true);
                  storeBinderDetails();
                }}
              >
                {binderLetterStatus === PossibleApiStatusValues.loading ? (
                <ReactLoading type="bars" width={30} height={30} />
              ) : binderLetterStatus === PossibleApiStatusValues.success ? (
                <div>
                  {
                    translations[languagecode]?.binderLetter
                      .downloadBinderLetterAgain
                  }
                </div>
              ) : binderLetterStatus === PossibleApiStatusValues.failed ? (
                <div>
                  {
                    translations[languagecode]?.binderLetter
                      .downloadFailedReported
                  }
                </div>
              ) : (
                <div>
                  {
                    translations[languagecode]?.binderLetter
                      .confirmAndCreateBinderLetter
                  }
                </div>
              )}
              </Dropdown.Item>
              <Dropdown.Item
                style={{
                  width: "100%",
                }}
                eventKey="2"
                onClick={() => {
                  var effectiveDate = new Date(
                    binderDetails.binderdetails.effectivedate
                  )?.toDateString();
                  var businessName =
                    binderDetails.binderdetails.CLIENT_BUSINESS_NAME;
                  const brokerName = binderDetails.binderdetails.brokername;
                  var premium = binderDetails.binderdetails.covers[3];
                  const clientName = binderDetails.binderdetails.CLIENT_EMAIL;
                  storeBinderDetails({
                    downloadingEml: true,
                    mailto: clientName ? clientName : "",
                    bcc: "",
                    body: emailBodyBindLetter[languagecode].replace(
                      "<<brokername>>",
                      brokerName + " " //temporay fix, but the replace function is removing the last char in string everytime. the space is a gap to ensure it doesn't
                    ),
                    subject: translations[languagecode].binderLetter.confirmAndCreateBinderInsurance ,
                  });
                }}
              >
              {binderLetterStatus === PossibleApiStatusValues.loading ? (
                <ReactLoading type="bars" width={30} height={30} />
              ) : binderLetterStatus === PossibleApiStatusValues.success ? (
                <div>
                  {
                    translations[languagecode]?.binderLetter
                      .downloadBinderLetterEmailAgain
                  }
                </div>
              ) : binderLetterStatus === PossibleApiStatusValues.failed ? (
                <div>
                  {
                    translations[languagecode]?.binderLetter
                      .downloadFailedReported
                  }
                </div>
              ) : (
                <div>
                  {
                    translations[languagecode]?.binderLetter
                      .confirmAndCreateBinderLetterEmail
                  }
                </div>
              )}
              </Dropdown.Item>
            </DropdownButton>
          </div>
        </div>
      </div>
    </div>
    <PdfSettingsModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

const Description = ({ inputStyle, storeBinder, props, setStoreBinder }) => {
  return (
    <div className="col-md-6">
      <input
        type="text"
        name="Operation"
        style={inputStyle}
        value={storeBinder && storeBinder.description}
        placeholder="Test description in this field"
        onChange={(event) => {
          const temp = { ...storeBinder };
          temp.description = event.target.value;
          temp.policyid = props.binderId;
          setStoreBinder(temp);
        }}
      />
    </div>
  );
};

const BrokerComments = ({ inputStyle, storeBinder, setStoreBinder }) => {
  return (
    <div className="col-md-6">
      <input
        type="text"
        name="General"
        style={inputStyle}
        placeholder="Test description in this field"
        value={storeBinder && storeBinder.comment}
        onChange={(event) => {
          const temp = { ...storeBinder };
          temp.comment = event.target.value;
          setStoreBinder(temp);
        }}
      />
    </div>
  );
};
export default BindLetterModal;
